'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_io$002eintela$002esites$002eintelacloud$002econtent$002e$002dHue from "./io.intela.sites.intelacloud.content.-Hue.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_intelacloud_content_Hue$$anon$1(\u03b4name$3, _$ordinal$3) {
  this.jS = null;
  this.jS = \u03b4name$3;
}
export { $c_Lio_intela_sites_intelacloud_content_Hue$$anon$1 as $c_Lio_intela_sites_intelacloud_content_Hue$$anon$1 };
$p = $c_Lio_intela_sites_intelacloud_content_Hue$$anon$1.prototype = new $j_io$002eintela$002esites$002eintelacloud$002econtent$002e$002dHue.$h_Lio_intela_sites_intelacloud_content_Hue();
$p.constructor = $c_Lio_intela_sites_intelacloud_content_Hue$$anon$1;
/** @constructor */
function $h_Lio_intela_sites_intelacloud_content_Hue$$anon$1() {
}
export { $h_Lio_intela_sites_intelacloud_content_Hue$$anon$1 as $h_Lio_intela_sites_intelacloud_content_Hue$$anon$1 };
$h_Lio_intela_sites_intelacloud_content_Hue$$anon$1.prototype = $p;
$p.G = (function() {
  return 0;
});
$p.H = (function(n) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.I = (function() {
  return this.jS;
});
$p.r = (function() {
  return this.jS;
});
$p.q = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I(this.jS);
});
var $d_Lio_intela_sites_intelacloud_content_Hue$$anon$1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_intelacloud_content_Hue$$anon$1, "io.intela.sites.intelacloud.content.Hue$$anon$1", ({
  eN: 1,
  eL: 1,
  b: 1,
  e: 1,
  a: 1,
  Q: 1,
  ah: 1,
  U: 1,
  af: 1,
  ag: 1
}));
export { $d_Lio_intela_sites_intelacloud_content_Hue$$anon$1 as $d_Lio_intela_sites_intelacloud_content_Hue$$anon$1 };
//# sourceMappingURL=io.intela.sites.intelacloud.content.-Hue$$anon$1.js.map
